import React, { useRef, useEffect } from "react";
import { Card } from "react-bootstrap";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import "./Calendar.css";

const CalendarComponent = ({ tasks, selectTask }) => {
  const calendarRef = useRef(null);

  useEffect(() => {
    if (!calendarRef.current) return;
    const calendarApi = calendarRef.current.getApi();
    calendarApi.removeAllEvents();
    tasks.forEach((task) => {
      if (task.deadline) {
        calendarApi.addEvent({
          id: task.id,
          title: task.title,
          start: task.deadline,
          color: getPriorityColor(task.priority),
        });
      }
    });
  }, [tasks]);

  const handleEventClick = (clickInfo) => {
    const taskId = clickInfo.event.id;
    const task = tasks.find((t) => t.id === taskId);
    if (task) {
      selectTask(task);
    }
  };

  return (
    <Card className="calendar-card shadow-sm">
      <Card.Body>
        <div className="calendar-header d-flex flex-wrap align-items-center justify-content-between mb-3 gap-2">
          <div>
            <h5 className="mb-0">タスクカレンダー</h5>
            <small className="text-muted">締め切りと予定を月/週/日で確認</small>
          </div>
          <div className="text-muted small d-flex align-items-center gap-1">
            <i className="bi bi-hand-index-thumb"></i>
            イベントをクリックして詳細を表示
          </div>
        </div>
        <FullCalendar
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          headerToolbar={{
            left: "prev,next today",
            center: "title",
            right: "dayGridMonth,timeGridWeek,timeGridDay",
          }}
          buttonText={{
            today: "今日",
            month: "月",
            week: "週",
            day: "日",
          }}
          locales={[jaLocale]}
          locale="ja"
          dayHeaderFormat={{ weekday: "short" }}
          titleFormat={{ year: "numeric", month: "long" }}
          events={[]}
          ref={calendarRef}
          eventClick={handleEventClick}
          height="auto"
          firstDay={1}
          slotLabelFormat={{
            hour: "2-digit",
            minute: "2-digit",
            meridiem: false,
          }}
        />
      </Card.Body>
    </Card>
  );
};

const jaLocale = {
  code: "ja",
  week: {
    dow: 1,
    doy: 4,
  },
  buttonText: {
    prev: "前",
    next: "次",
    today: "今日",
    month: "月",
    week: "週",
    day: "日",
    list: "一覧",
  },
  weekText: "週",
  allDayText: "終日",
  moreLinkText: (n) => `他 ${n} 件`,
  noEventsText: "表示する予定がありません",
};

// 優先度に応じたカラー取得
const getPriorityColor = (priority) => {
  switch (priority) {
    case "high":
      return "#dc3545"; // Bootstrapのdanger色
    case "medium":
      return "#ffc107"; // Bootstrapのwarning色
    case "low":
      return "#198754"; // Bootstrapのsuccess色
    default:
      return "#6c757d"; // Bootstrapのsecondary色
  }
};

export default CalendarComponent;
